import React from 'react';
import './../CSS/hambuger.css'; // Import your CSS file for styling
import { GiHamburgerMenu } from 'react-icons/gi';
import { FaTimes } from 'react-icons/fa';


const Hamburger = ({  isOpen, toggleMenu }) => {
    return (
      <div className="hamburger"  onClick={toggleMenu}>
          {isOpen ? <FaTimes /> : <GiHamburgerMenu />}
      </div>
    );
  };

export default Hamburger; 